import { IAddressDto } from './address.model';
import { ITotalRecords } from './common.model';
import { CartMenuItemsDto } from './menu.model';
import { IGuestUserDto, IUserDto } from './user.model';

export interface IAdminOrderDto extends ITotalRecords {
  id: number;
  outletId: number;
  orderId: string;
  userType: string;
  phone: string;
  paymentModeId: number;
  paymentMode: string;
  paymentModeName: string;
  deliveryType: number;
  deliveryTypeName: string;
  orderSource: string;
  isScheduleOrder: boolean;
  orderDate: Date;
  scheduleDate: Date;
  scheduleTime: string;
  orderAmount: number;
  customerName: string;
  orderStatus: number;
  customOrderTime: number;
  deliveryTime: number;
  pickupTime: number;
  timeZone: string;
  restaurantName: string;
  outletName: string;
}

export interface IPaidOrderDto extends ITotalRecords {
  orderId: string;
  restaurantName: string;
  outletName: string;
  customerName: string;
  userType: string;
  orderAmount: number;
  orderSource: string;
  deliveryTypeName: string;
  orderDate: Date | string;
}

export interface IOrderDto {
  id: number;
  orderId: string;
  orderStatus: number;
  orderDateWithOffset: Date;
  orderDate: Date;
  acceptedDate: Date;
  customTime: number;
  timeSlot: number;
  orderJson: string;
  isNew: boolean;
  tableNo: string;
  pickupTime: number;
  deliveryTime: number;
  timeZone: string;
  outletName: string;
  currency: string;
  currencyCode: string;
  restaurantId: number;
  outletId: number;
  restaurantName: string;
  outletPhone: number;
  outletEmail: string;
  merchantEmail: string;
  batchNo: string;
  outletGuid: string;
  outletAddress: string;
  transactionNo: string;
  user: IUserDto;
  billing: IBillingDto;
  menuItems: CartMenuItemsDto[];
  paymentMode: number;
  isRefund: boolean;
  isPartialRefund: boolean;
  refundedAmount: number;
  paymentStatusId: number;
  paymentStatus: string;
  creditCardAmount: number;
  isShipDayDelivery: boolean;
  isManualOrder: boolean;
  isShipDayActionBtn: boolean;
  isShipDayRefundBtn: boolean;
  shipDayOrderStatus: string;
}

export class IManualOrderDto {
  batchNo: string;
  transactionNo: string;
}

export class IRefundDto {
  orderId: number;
  amount: number;
  refundType: number;
  otp: number;
  token: string;
}

export class IOtpDto {
  outletId: number;
  orderId: number;
  // paymentMode: number;
  otpType: number;
}
export interface IBillingDto {
  orderId: string;
  restaurantId: number;
  outletId: number;
  deliveryType: number;
  scheduledOrderDate: string;
  scheduledOrderTime: string;
  paymentType: number;
  specialInstructions: string;
  isTableOrder: boolean;
  isScheduleOrder: boolean;
  isGuestUser: boolean;
  isRewardPoints: boolean;
  isCouponApplied: boolean;
  isVoucherApplied: boolean;
  isTipPaid: boolean;
  rewardsEarned: number;
  cartAmount: number;
  couponDiscount: number;
  rewardsDiscount: number;
  discountedAmount: number;
  deliveryCharges: number;
  tipAmount: number;
  totalTaxes: number;
  totalFees: number;
  tableId: number;
  taxes: IBillingTaxDto[];
  fees: IBillingFeeDto[];
  cartItems: any[];
  tip: IBillingTipDto;
  coupon: IBillingCouponDto;
  voucher: IBillingVoucherDto;
  guestUser: IGuestUserDto;
  address: IAddressDto;
  totalAmount: number;
  orderSource: number;
  isAdvancePickup: boolean;
  advancePickup: IAdvancePickupDto;
  miles: number;
}
export interface IBillingTaxDto {
  name: string;
  rate: number;
  amount: number;
}
export interface IBillingFeeDto {
  name: string;
  type: number;
  calculationType: number;
  amount: number;
  description?: string;
}
export interface IBillingTipDto {
  id: number;
  name: string;
  type: number;
  amount: number;
  custom: boolean;
  customValue: number;
}

export interface IBillingCouponDto {
  id: number;
  name: string;
  code: string;
  amount: number;
}

export interface IBillingVoucherDto {
  id: number;
  type: number;
  amount: number;
  code: string;
}

export interface IAdvancePickupDto {
  id: number;
  title: string;
  advancePickupDetails: IAdvancePickupDetailsDto[];
}

export interface IAdvancePickupDetailsDto {
  id: number;
  question: string;
  answer: string;
}
